var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicLargeTop = function SvgOrganicLargeTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2266 942",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.691 905.381c.002-168.446-28.799-524.996 102.001-739.968 163.5-268.714 414.5-160.426 752.5 0C1262.19 325.84 1498.69 301.776 1860.69 371.461 2150.29 427.21 2264 783 2264 942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2226 941.979H2.691c.002-167.999-28.799-523.6 102.001-738 163.5-268 414.5-160 752.5 0 337.998 160 574.498 136 936.498 205.5C2083.29 465.079 2226 785 2226 941.979Z",
    fill: "#F5F0E7"
  })));
};
export default SvgOrganicLargeTop;